"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.happyClient = exports.coveredBy = exports.directConnectionData = exports.Insights = exports.TrekLists = exports.NavLinks = exports.companyLinks = exports.address = exports.emails = exports.socialMediaLinks = exports.otherLinks = exports.footerQuotes = exports.featuredByList = void 0;

var _config = _interopRequireDefault(require("@dom/config"));

var featuredByList = [{
  href: 'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking/',
  imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/test/lp-org.jpg'
}, {
  href: 'https://besthike.com/2018/09/07/new-app-trekking-in-nepal/',
  imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/test/besthike.jpg'
}, {
  href: 'https://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
  imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/test/woldbank.jpg'
}, {
  href: 'https://bwdisrupt.businessworld.in/article/7-Startups-in-Nepal-That-Caught-Our-Eye-/23-06-2016-99539/',
  imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/test/businessworld.jpg'
}, {
  href: 'https://www.kimkim.com/c/best-apps-for-nepal',
  imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/test/kimkim.jpg'
}, {
  href: 'https://www.slush.org/company/honeyguide-apps/',
  imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/test/slush.jpg'
}];
exports.featuredByList = featuredByList;
var footerQuotes = [{
  quote_1: 'Going to the mountains',
  quote_2: 'is going home',
  author: 'John Muir'
}, {
  quote_1: 'Great things are done when',
  quote_2: 'men and mountains meet',
  author: 'William Blake'
}, {
  quote_1: 'There is no such thing as bad weather,',
  quote_2: 'only inappropriate clothing',
  author: 'Sir Ranulph Fiennes'
}];
exports.footerQuotes = footerQuotes;
var otherLinks = {
  // youtubeUrl: 'https://www.youtube.com/embed/huei98Y6Cq0',
  youtubeUrl: 'https://www.youtube.com/embed/QDg23cCuc5E',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.trekkinginnepal.app&hl=en',
  appStoreUrl: 'https://itunes.apple.com/np/app/trekking-in-nepal/id1112263577?mt=8'
};
exports.otherLinks = otherLinks;
var socialMediaLinks = [{
  text: 'facebook',
  link: 'https://www.facebook.com/honeyguideapp/'
}, {
  text: 'twitter',
  link: 'https://twitter.com/honeyguideapps'
}, {
  text: 'instagram',
  link: 'https://www.instagram.com/honeyguideapps/'
}, {
  text: 'pinterest',
  link: 'https://www.pinterest.com/honeyguideapps/'
}, {
  text: 'google-plus',
  link: 'https://plus.google.com/+Honeyguideapps'
}];
exports.socialMediaLinks = socialMediaLinks;
var emails = [{
  text: 'Ashish Shrestha',
  email: 'honeyhunter@honeyguideapps.com',
  number: '+977-9841370673'
}];
exports.emails = emails;
var address = [{
  country: 'United States Office',
  address1: '2035 Sunset Lake Rd Suite B-2,',
  address2: 'Newark, New Castle, DE-19702.'
}, {
  country: 'India Office',
  address1: 'Flat No 1-D, Top Floor, DDA Flats Pocket-1, Sector-7,',
  address2: 'Dwarka, New Delhi-110075, Delhi.'
}, {
  country: 'Nepal Office',
  address1: 'Nuwakott Ghar, Sanepa Chowk,',
  address2: 'Lalitpur-44700, Province Number-3.'
}];
exports.address = address;
var companyLinks = [{
  text: 'About Us',
  link: '/about-us'
}, {
  text: 'Places',
  link: '/places'
}, {
  text: 'Explore',
  link: '/explore'
}, {
  text: 'Blog',
  link: '/blog/'
}, {
  text: 'Careers',
  link: '/careers'
}, {
  text: 'Privacy Policy',
  link: '/policies/privacy'
}, {
  text: 'Terms of Services',
  link: '/policies/terms-services'
}];
exports.companyLinks = companyLinks;
var NavLinks = [{
  name: 'Explore',
  url: '/explore'
}, {
  name: 'Treks',
  url: '/treks'
}, {
  name: 'Place',
  url: '/places'
}];
exports.NavLinks = NavLinks;
var TrekLists = [{
  name: 'Everest Base Camp Trek',
  day: 14,
  url: '/treks/everest-base-camp-trek.e9454db30a8e.everest-region',
  price: '649',
  img: 'everest-three-passes-trek.jpg'
}, {
  name: 'Gokyo lakes and Gokyo Ri trek',
  day: 12,
  url: 'treks/gokyo-lakes-and-gokyo-ri-trek.e4e63a14f912.everest-region',
  price: '576.5',
  img: 'everest-base-camp-trek-gokyo.jpg'
}, {
  name: 'Everest Panorama Trek',
  day: 8,
  url: 'treks/everest-panorama-trek.e3f368f3159e.everest-region',
  price: '496.5',
  img: 'everest-panorama-trek.jpg'
}, {
  name: 'Salleri To Everest Base Camp Trek',
  day: 18,
  url: 'treks/salleri-to-everest-base-camp-trek.e5947a6fc43c.everest-region',
  price: '532',
  img: 'salleri-to-everest-base-camp-trek.jpg'
}, {
  name: 'Gokyo Lakes and EBC Trek',
  day: 12,
  url: 'treks/gokyo-lakes-and-everest-base-camp-trek-cho-la-circuit.e8ce3b049cfe.everest-region',
  price: '576.5',
  img: 'everest-base-camp-trek-gokyo-chola.jpg'
}, {
  name: ' Everest Three Passes Trek ',
  day: 19,
  url: 'treks/everest-three-passes-trek-with-everest-base-camp.e21b62630f7a.everest-region',
  price: '801',
  img: 'everest-base-camp-trek-pheriche.jpg',
  extraClassName: ''
}, {
  name: 'Sweet Gold (Honey Hunting Trek) ',
  day: 9,
  url: 'treks/sweet-gold-honey-hunting-trek.e60bf6bb2f2f.annapurna-region',
  price: '850',
  img: 'trip/e822c2c9ea45.jpeg'
}, {
  name: 'Bird Watching Holiday in Annapurna',
  day: 10,
  url: 'treks/himalayan-birds-bird-watching-holiday-in-annapurna.e822c2c9ea45.annapurna-region',
  price: '1650',
  img: 'trip/e60bf6bb2f2f.jpeg'
}, {
  name: 'Everest Base Camp with Sonam',
  day: 12,
  url: 'treks/everest-base-camp-trek-dingboche.e7d6353b261e.everest-region',
  price: '1300',
  img: 'everest-base-camp-trek-dingboche.jpg'
}];
exports.TrekLists = TrekLists;
var Insights = [{
  name: 'Everything about Everest',
  desc: '',
  type: 'Planning Guides',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/ashish-shrestha.jpg"),
  author: 'Ashish Shrestha',
  link: '/p/everything-about-the-everest-base-camp-trek'
}, {
  name: ' Hippest Intro to Nepal',
  desc: '',
  type: 'Fun Introduction',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/nepali-travellers.jpg"),
  author: 'Nepali Travellers',
  link: '/p/intro-to-nepal '
}, {
  name: 'Trekking Checklist',
  desc: '',
  type: 'Quick Planning',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/ashik-shrestha.jpg"),
  author: 'Ashik Shrestha',
  link: '/p/trekking-in-nepal-checklist'
}, {
  name: 'Health and Safety',
  desc: '',
  type: 'Stay Safe',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/honeyguide.png"),
  author: 'HoneyGuide',
  link: '/p/health-and-safety-while-trekking-in-nepal'
}, {
  name: 'Namche Bazaar',
  desc: '',
  type: 'Place Information',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/everest-marathon.png"),
  author: 'Everest Marathon',
  link: '/namche.d840302e4958.everest-region'
}, {
  name: 'Everest Inn',
  desc: '',
  type: 'Lodge Contacts',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/snow-leopard-conservancy.jpg"),
  author: 'Snow Leopard Conservancy',
  link: '/hotel-everest-inn.b5bc2a0d9204.gorakshep-lodges'
}, {
  name: 'Trekking in Nepal',
  desc: '',
  type: 'Mobile App',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/rajendra-suwal.jpg"),
  author: 'Rajendra Suwal, WWF',
  link: '#mobile-app'
}, {
  name: 'End of Free Rooms',
  desc: '',
  type: 'Fun Blogs',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/jamling-tenzing-norgay.jpg"),
  author: 'Jamling Tenzing Norgay',
  link: '/blog/the-end-of-free-rooms-in-everest-good-or-bad'
}, {
  name: 'Everything about ABC',
  desc: 'Perhaps the most famous icon of the Himalayas, this biped ape is the stuff of both legend and scientific scrutiny. Sherpa folklore distinguishes three different kinds of yeti each with its own physical and behavioral traits. Western interest in the yeti can be traced back to the beginning of mountaineering in the Himalayas. The most famous ‘evidence’ from this time was the image of yeti tracks photographed by Eric Shipton during the 1951 attempt on Everest. While it had very little scientific value, it sure did bag a handsome $8,000 in a 2013 auction. There were also a lot of yeti hunts in the Himalayas by people as famous as Sir Ed Hillary and Reinhold Messner. Unfortunately for the believers, both of them have subsequently recanted their belief in the snowman.',
  type: 'Everest Base Camp',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/radioactive-wiki.jpeg"),
  author: 'Radioactive Uber Wiki',
  link: '/p/everything-about-the-annapurna-base-camp-trek'
}, {
  name: 'When to go to Everest',
  desc: 'Let us give into some statistical fear mongering: 40-50% people get sick with altitude illness upon trekking to 4,000m in Nepal; about eight out of a hundred thousand people die of altitude related illnesses every year in Nepal and despite the availability of rescue services, the number is increasing',
  type: 'Safety ',
  icon: 'icon-land icon--small icon-svg icon-svg--white',
  img: "".concat(_config["default"].ASSETS_URL, "/prasit-sthapit.jpg"),
  author: 'Prasiit Sthapit',
  link: '/p/everything-about-the-everest-base-camp-trek#when-to-go-to-everest-base-camp?'
}];
exports.Insights = Insights;
var directConnectionData = [{
  lodgeName: 'Edelweiss Lodge',
  location: 'Pheriche',
  desc: 'I believe that lodges in Everest Region should focus on High Quality service and Self Empowerment',
  ownerName: 'Lhakpa Sherpa',
  classNameNumber: 2,
  img: 'assets/img/lhakpa-sherpa.jpeg',
  url: '/the-edelweiss.b5f96b220426.pheriche-lodges'
}, {
  lodgeName: 'Local Guide',
  location: '',
  desc: 'I am happy to guide people through HoneyGuide because people can know that there is a guide named Sonam. I hope that I can get regular clients in trekking season time. I would love to show everybody my home town of Everest and take them to my small tea shop in Phakding as well!',
  ownerName: 'Sonam Dorjee Sherpa',
  classNameNumber: 3,
  img: 'https://s3.amazonaws.com/honeyguide/assets/soman-guide.jpg',
  url: '/sonam-dorjee-sherpa.a4d6fc0c92b7'
}, {
  lodgeName: 'Everest Inn',
  location: 'Gorakshep',
  desc: 'Everest is a piece of heaven on earth and we are here at the gateway to serve the people who come here. Empower us by booking directly.',
  ownerName: 'Pasang Tsering Sherpa',
  classNameNumber: 4,
  img: 'assets/img/pasang-tsering-sherpa.jpg',
  url: '/hotel-everest-inn.b5bc2a0d9204.gorakshep-lodges'
}, {
  lodgeName: 'Guide',
  location: '',
  desc: 'Trekking companies are generally making hefty amount of money just by making workers work hard and grabbing their wages as commission which is why I decided to quit the agency I was last working for.And now I have found Honey Guide as the best platform to showcase my guiding brilliance.',
  ownerName: 'Bishwas Aryal',
  classNameNumber: 6,
  img: 'https://s3.amazonaws.com/honeyguide/assets/biswash-guide.jpg',
  url: '/bishwas-aryal.a4a1f0ab6e3e'
}, {
  lodgeName: 'Namaste Lodge and Restaurant',
  location: 'Phakding',
  desc: 'It is the time of technology. And through HoneyGuide, we are learning how to use it to be better and make the existing system in Everest Region.',
  ownerName: 'Chimmi Tenzing Sherpa',
  classNameNumber: 7,
  img: 'assets/img/chimmi-sherpa.jpg',
  url: '/namaste-lodge-restaurant-and-bar.b77ba10e0944.phakding-lodges'
}, {
  lodgeName: 'Namaste Lodge and Restaurant',
  location: 'Monjo',
  desc: 'I run a small lodge but I make sure every trekkers leave happily when they go. I even grow my own vegetables and serve organic food. At HoneyGuide, even small lodges like mine get equal opportunity to be noticed!',
  ownerName: 'Phuraphuti Sherpa',
  classNameNumber: 8,
  img: 'assets/img/phuraphuti-sherpa.jpg',
  url: '/namaste-lodge-and-restaurant.b80f1ffd0b93.monjo-lodges'
}, {
  lodgeName: 'Hotel Khangri',
  location: 'Namche Bazaar',
  desc: 'Hassle free online booking with availability of choices in the mountains.',
  ownerName: 'Dawang Sherpa',
  classNameNumber: 9,
  img: 'assets/img/dawang-sherpa.jpg',
  url: '/hotel-khangri.b9123c009dc0.namche-bazaar-lodges'
}];
exports.directConnectionData = directConnectionData;
var coveredBy = [{
  name: 'Lonely Planet',
  url: 'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking',
  desc: 'Putting the HoneyGuide app ahead of its competitors, maps and trail descriptions can be used offline, so you can dip in and out of reception as you drop into mountain valleys without losing functionality. ',
  img: 'assets/img/lp.jpg'
}, {
  name: 'Best Hike',
  url: 'https://besthike.com/2018/09/07/new-app-trekking-in-nepal',
  desc: 'Putting the HoneyGuide app ahead of its competitors, maps and trail descriptions can be used offline, so you can dip in and out of reception as you drop into mountain valleys without losing functionality. ',
  img: 'https://s3.amazonaws.com/honeyguide/assets/besthike.jpg'
}, {
  name: 'World Bank',
  url: 'http://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
  desc: 'Digital entrepreneurs often talk excitedly about disrupting industries, but rarely do you find such excitement when talking about guidebooks. Ashish Shrestha, one of the founders of Honeyguide, wants to give travelers to Nepal a better all-around experience, from booking their travel to navigating the trails and learning about the local culture.',
  img: 'https://s3.amazonaws.com/honeyguide/assets/test/woldbank.jpg'
}, {
  name: 'Business World',
  url: 'http://bwdisrupt.businessworld.in/article/7-Startups-in-Nepal-That-Caught-Our-Eye-/23-06-2016-99539/',
  desc: 'Guidebooks are dead!! Millennial travelers have no patience with its format or content. They want the technology to bend around their needs. While they are trekking, they don’t want a guidebook, they want a trekking app. And they want the technology to make them instant experts. HoneyGuide’s Trekking in Nepal provides just that through its features like Mountain Finder,    context sensitive Placecards, Deviation Alerts, complete lodge info in a small offline package.',
  img: 'https://s3.amazonaws.com/honeyguide/assets/test/businessworld.jpg'
}, {
  name: 'Kim Kim',
  url: 'https://www.kimkim.com/c/best-apps-for-nepal',
  desc: "HoneyGuide is Nepal's first trekking guide app. Pick your trek, then select categories of interest (mountains, flowers, animals, culture, etc.) so that you can preview and learn about what you'll come across.",
  img: 'https://s3.amazonaws.com/honeyguide/assets/test/kimkim.jpg'
}, {
  name: 'New Business Age',
  url: 'http://www.newbusinessage.com/MagazineArticles/view/1960',
  desc: 'The app also provides information on each village on the trekking routes, such as all available lodges through GPS and information on flora and fauna in the localities. The app is in fact a one-stop solution for trekkers enabling them to have instant access to all necessary information even if they are offline.',
  img: 'assets/img/nba.jpg'
}, {
  name: 'A Year Off life',
  url: 'https://ayearofflife.com/2017/06/01/what-bring-us-together-annapurna-circuit/',
  desc: 'Great app with plenty information about trip preparations, itineraries, lodges, and services. RECOMMENDED.',
  img: 'assets/img/ayl.jpg'
}];
exports.coveredBy = coveredBy;
var happyClient = [{
  name: 'Greg Anderson',
  desc: 'At first I was a bit reluctant given that the prices are so low here. However, on closer look I realized that these are prices directly from the local service providers. Also, it is really easy to book lodges and flights. It was also a great surprise to get a choice of soup included in the booking price. I would highly recommend this service to anyone.',
  img: 'https://s3.amazonaws.com/honeyguide/assets/greg-anderson.jpg',
  title: 'PR/Marketing'
}, {
  name: 'Jonas Schlör',
  desc: 'Used this for the Annapurna Base Camp trek. Perfect in every way. Detailed descriptions of places, lodges and nature. Would definitely use again if I ever go trekking in Nepal again.',
  img: 'https://s3.amazonaws.com/honeyguide/assets/jonas-schlor.jpg',
  title: 'Team Leader'
}, {
  name: 'Birgit Fischer',
  desc: 'It is good that we get booking service. Also we stayed one night at Gorakshep. It was easy to change bookings. The weather was good and we loved the trek. Very useful for hike on your own.',
  img: 'https://s3.amazonaws.com/honeyguide/assets/birgit-fischer.jpg',
  title: 'Team Leader'
}];
exports.happyClient = happyClient;